var scope_0 = require('/home/bdudelsack/Projects/bdudelsack.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8a51a4c3df89221e16c6cf9ae96c6326.js').default;
var scope_1 = require('/home/bdudelsack/Projects/bdudelsack.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d96e120d56eda097debdf03c9be23be9.js').default;
var scope_2 = require('/home/bdudelsack/Projects/bdudelsack.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    